import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { DISH_DRAWER_TYPES } from '../../constants'
import { updateDishDrawer, updateDishTableHotkeys } from '../../redux/actions'
import { StyledDishDrawer } from '../styled'

import DishDetailsDrawerContent from './dish-details-drawer-content'
import DishIngredientsDrawerContent from './dish-ingredients-drawer-content'

const DishDrawer = ({ isDisabled }) => {
  const dispatch = useDispatch()
  const { selectedDishId, selectedDrawerType } = useSelector(
    store => store.dishes.dishes?.drawer,
  )

  const isVisible = useMemo(() => !isNil(selectedDishId), [selectedDishId])

  const handleClose = () => {
    dispatch(updateDishTableHotkeys({ isDrawerNavigationEnabled: false }))
    dispatch(
      updateDishDrawer({ selectedDishId: null, selectedDrawerType: null }),
    )
  }

  const title = useMemo(() => {
    switch (selectedDrawerType) {
      case DISH_DRAWER_TYPES.MAIN_INGREDIENTS:
        return 'Main Ingredients'
      case DISH_DRAWER_TYPES.CHOICE_INGREDIENTS:
        return 'Choice Ingredients'
      case DISH_DRAWER_TYPES.DISH_DETAILS:
        return 'Dish Details'
      default:
        return ''
    }
  }, [selectedDrawerType])

  const content = useMemo(() => {
    switch (selectedDrawerType) {
      case DISH_DRAWER_TYPES.MAIN_INGREDIENTS:
        return (
          <DishIngredientsDrawerContent
            dishId={selectedDishId}
            drawerType={selectedDrawerType}
            isDisabled={isDisabled}
          />
        )
      case DISH_DRAWER_TYPES.CHOICE_INGREDIENTS:
        return (
          <DishIngredientsDrawerContent
            dishId={selectedDishId}
            drawerType={selectedDrawerType}
            isDisabled={isDisabled}
          />
        )
      case DISH_DRAWER_TYPES.DISH_DETAILS:
        return <DishDetailsDrawerContent dishId={selectedDishId} />
      default:
        return null
    }
  }, [selectedDrawerType, selectedDishId, isDisabled])

  return (
    <StyledDishDrawer
      placement="right"
      width={450}
      mask={false}
      title={title}
      visible={isVisible}
      onClose={handleClose}
    >
      {content}
    </StyledDishDrawer>
  )
}

DishDrawer.propTypes = {
  isDisabled: PropTypes.bool,
}

DishDrawer.defaultProps = {
  isDisabled: false,
}

export default DishDrawer
